// Translator notes: Derived words read as a guess (engine/src/derivation.ts).
// Each id is an engine note (`notes.add(text, id, args)`); `args` names its arguments in the order the
// strings take them. Collected by translator/notes.ts (import.meta.glob): adding a note means adding it here.
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  derivedWord: {
    args: ['word', 'root', 'rootGloss', 'affix'],
    fi: (a: string[]) =>
      `Sanaa ${a[0]} ei ole sanakirjassa. Se on todennäköisesti sanan ${a[1]} ’${a[2]}’ ja päätteen ${a[3]} johdos, mutta tarkkaa merkitystä ei tiedetä – siksi käännös on epävarma.`,
    en: (a) =>
      `${a[0]} is not in the dictionary. It is probably ${a[1]} ‘${a[2]}’ + the suffix ${a[3]}, but its exact meaning is not known – so the translation is uncertain.`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
